import { call, put, takeLatest } from "redux-saga/effects";
import {
  getAssignedFeeStructureToCalssRequest,
  getAssignedFeeStructureToCalssSuccess,
} from "./assignFeesStructureToClassSlice"; 
import { getAllAssignedFeeStructureToCalssMapping } from "../../api/assignedFeeStructureToCalss/GetAssignedFeeStructureToCalssService";

function* fetchAssignedFeeStructureToCalssSaga(action) {
  try {
    const {schoolID, query} = action.payload;
    const response = yield call(getAllAssignedFeeStructureToCalssMapping, schoolID, query);
    yield put(getAssignedFeeStructureToCalssSuccess(response?.data)); 
  } catch (error) {
    yield put(getAssignedFeeStructureToCalssSuccess([])); 
    // yield put(getAssignedFeeStructureToCalssFailure(error.message || "Something went wrong"));
  }
}

export default function* watchAssignedFeeStructureToCalss() {
  yield takeLatest(getAssignedFeeStructureToCalssRequest.type, fetchAssignedFeeStructureToCalssSaga);
}

